const SMB_PUBLIC_STORE_SELF_SIGN_UP = 'public-store-self-signup';

/*
 * These are the supported options for the account group origin
 * New origins should be added here:
 * */
export const ACCOUNT_GROUP_ORIGIN_OPTIONS = [
  {
    label: 'AUTOMATIONS.EDITOR.FILTERS.ACCOUNT_GROUP_ORIGIN.OPTION_LABELS.CREATED_BY_SMB_SELF_SIGN_UP',
    value: SMB_PUBLIC_STORE_SELF_SIGN_UP,
  },
];
